import { Table, TableContainer, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import React from "react";
import LogRow from "./LogRow";

export default function ToolFunctionInvokeLogs(props) {
  return (
    <TableContainer p={3} h={"auto"} borderRadius={"md"} overflowY={"auto"}>
      <Table size={"sm"} variant="striped" h={"100%"}>
        <Thead>
          <Tr>
            <Th>Tool name</Th>
            <Th>Tool user name</Th>
            <Th>Tool function name</Th>
            <Th>Widget name</Th>
            <Th>Timestamp</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {props.logs.map((log) => (
            <LogRow
              key={log.id}
              onOpenShowModal={props.onOpenShowModal}
              onOpenCallDetailsModal={props.onOpenCallDetailsModal}
              onDeleteLog={props.onDeleteLog}
              log={log}
            />
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
